var map = {
	"./68939001295348218721cacc/dessert.png": [
		465,
		465
	],
	"./68939001295348218721cacc/friedpopcorn.png": [
		146,
		146
	],
	"./68939001295348218721cacc/madewithlove.png": [
		528,
		528
	],
	"./68939001295348218721cacc/maggie.png": [
		881,
		881
	],
	"./68939001295348218721cacc/momo's.png": [
		833,
		833
	],
	"./68939001295348218721cacc/pasta.png": [
		610,
		610
	],
	"./68939001295348218721cacc/pizza.png": [
		381,
		381
	],
	"./68939001295348218721cacc/samosa.png": [
		807,
		807
	],
	"./68939001295348218721cacc/springroll.png": [
		485,
		485
	],
	"./68939001295348218721cacc/thickshakes.png": [
		481,
		481
	],
	"./68939001295348218721cacc/wraps.png": [
		992,
		992
	],
	"./689390e8295348218721cace/cbthickshakes.png": [
		808,
		427
	],
	"./689390e8295348218721cace/chai.png": [
		424,
		424
	],
	"./689390e8295348218721cace/coffee.png": [
		419,
		419
	],
	"./689390e8295348218721cace/friedsnacks.png": [
		292,
		292
	],
	"./689390e8295348218721cace/mojitos.png": [
		427,
		808
	],
	"./689390e8295348218721cace/popcorn.png": [
		384,
		384
	],
	"./689390e8295348218721cace/sandwich.png": [
		652,
		652
	],
	"./689390e8295348218721cace/teaspecial.png": [
		840,
		840
	],
	"./689390f8295348218721cacf/doublewaffles.png": [
		24,
		24
	],
	"./689390f8295348218721cacf/lassi.png": [
		933,
		933
	],
	"./689390f8295348218721cacf/mocktail.png": [
		193,
		193
	],
	"./689390f8295348218721cacf/potatotwister.png": [
		958,
		958
	],
	"./689390f8295348218721cacf/specialitems.png": [
		978,
		978
	],
	"./689390f8295348218721cacf/stickwaffles.png": [
		737,
		737
	],
	"./689390f8295348218721cacf/sweetcorn.png": [
		647,
		647
	],
	"./689390f8295348218721cacf/waffles.png": [
		841,
		841
	],
	"./restaurantImages/68939001295348218721cacc.png": [
		194,
		194
	],
	"./restaurantImages/689390e8295348218721cace.png": [
		954,
		954
	],
	"./restaurantImages/689390f8295348218721cacf.png": [
		776,
		776
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 598;
module.exports = webpackAsyncContext;